module.exports = __webpack_public_path__ + "img/reports.fac34f91.svg";